var Slider_Contact = {
	init:function(){
		$(window).resize(function(){
			Slider_Contact.resize();
		});

		Slider_Contact.resize();
	},

	resize:function(){

		var _carousel = $(".block-contact .arguments-list");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;
		var els = document.querySelectorAll(".arguments-list");

		Array.prototype.forEach.call(els, function(el) {
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));			
		});

		Debug.log("SLIDES TO SHOW IN CONTACT :" + _slides_to_show);

		if(_slides_to_show != 0){

			_carousel.slick({
				arrows:false, 
				dots:true,
				infinite: false,
				variableWidth:true,
				slidesToShow: _slides_to_show,
				focusOnSelect: true,
				touchThreshold:500,
			});	
		}
	}
}

$(window).load(function(){
	if($(".block-contact").length){
		Slider_Contact.init();
	}
})